// extracted by mini-css-extract-plugin
export var childrenContainer = "_bv-0";
export var virtualScrollArea = "_bv-1";